import { OfbizList, OfbizForm } from "@urbannex/ofbiz-forms";
import { ConfigOptions, ComponentConfig, getFields, getColumnFieldTitles, getIdFieldName, getTarget, getTargets, getTitleDescriptionField, getFieldSets, getAppContext } from "@urbannex/view-containers";
import { FEAT_FORMS } from "./forms";
import { NbMenuItem } from "@nebular/theme";

export const featureOptions:ConfigOptions = {
    name:"",
    title:"Feature Componment",
    menuAndTitleOptions:{
        path:"features",
        headerTitle:"Product Feature Categories",
        menuItems:[],
        menuTag:"featuresMenu"
    },
    listForm: new OfbizList({
      listType:"grid",
      listFormName:"ListProductFeatureCategories",
      listFormLocation:"component://kwikstore/widget/FeatureForms.xml",
      columnFields:getFields("ListProductFeatureCategories",FEAT_FORMS),
      columnFieldTitles:getColumnFieldTitles("ListProductFeatureCategories",FEAT_FORMS),
      appContext:"catalog",
      emptyListMessage:"No feature categories currently on system",
      remoteFormData:{
        formData:{
          formName:"ListProductFeatureCategories",
          formLocation:"component://kwikstore/widget/FeatureForms.xml",
          listType:"grid"
        }
      }
    }),
    addForm: new OfbizForm({
        local:true,
        formName:"EditProductFeatureCategory",
        formLocation:"component://kwikstore/widget/FeatureForms.xml",
        fields:getFields("EditProductFeatureCategory",FEAT_FORMS),
        titleDescriptionField:getTitleDescriptionField("EditProductFeatureCategory",FEAT_FORMS),
        idFieldName:getIdFieldName("EditProductFeatureCategory",FEAT_FORMS),
        fieldSets:getFieldSets("EditProductFeatureCategory",FEAT_FORMS),
    }),
    findForm:undefined,
    settings:[],
    actions:["list","find","add","edit"],
    breadCrumbData:{
      displayPrefix:"Product Feature Categories",
      label:"",
      level:1,
      selectedValue:{
        "event":"list",
        "type":"ListProductFeatures",
        "data":{
          formData:{
            formName:"ListProductFeatures",
            formLocation:"component://kwikstore/widget/FeatureForms.xml",
            listType:"grid"
          },
          "endPoint":"catalog",
          "parameters":{"productFeatureCategoryId":""}
        }
      },
      addFormText:"Create Feature Category",
      editFormText:"Update Feature Category"
    },
    relations:[
        {
            title:"Category Features",
            addContainerTitle:"Add Features to Category",
            listContainerTitle:"Features for Category",
            entityName:"ProductFeaturePrice",
            keyMap:{fieldName:"productFeatureId"},
            addFormName:"CreateFeaturePrice",
            listFormName:"ListFeaturePrice",
            listForm:new OfbizList({
                listType:"form",
                listFormName:"EditFeatureCategoryFeatures",
                listFormLocation:"component://kwikstore/widget/FeatureForms.xml",
                columnFields:getFields("EditFeatureCategoryFeatures",FEAT_FORMS),
                columnFieldTitles:getColumnFieldTitles("EditFeatureCategoryFeatures",FEAT_FORMS),
                idFieldName:getIdFieldName("EditFeatureCategoryFeatures",FEAT_FORMS),
                target:getTarget("EditFeatureCategoryFeatures",FEAT_FORMS),
                appContext:"catalog",
                remoteFormData:{
                formData:{
                    formName:"EditFeatureCategoryFeatures",
                    formLocation:"component://kwikstore/widget/FeatureForms.xml",
                    listType:"form",

                },
                parameters:{"productFeatureCategoryId":""}
                },
                emptyListMessage:"No Features found for this feature category"
            }),
            addForm:new OfbizForm({
                local:true,
                formName:"EditProductFeatureCategory",
                formLocation:"component://kwikstore/widget/FeatureForms.xml",
                fields:getFields("EditProductFeatureCategory",FEAT_FORMS),
                appContext:"catalog",
                idFieldName:"productFeatureCategoryId",
                targets:getTargets("EditProductFeatureCategory",FEAT_FORMS),
                titleDescriptionField:"description"
            }),
            /* breadCrumbData:{
                displayPrefix:"Features for ",
                label:"",
                level:2,
                selectedValue:{
                "event":"list",
                "type":"",
                "data":{
                    formData:{
                    formName:"",
                    formLocation:"component://kwikstore/widget/FeatureForms.xml"
                    }
                }
                },
                addFormText:"Create Product Feature",
                editFormText:"Update Product Feature"
            } */
        },
        {
            title:"Child Feature Categories",
            addContainerTitle:"Add Child Product Feature Category",
            listContainerTitle:"Child Product Feature Categories",
            keyMap:{fieldName:"productFeatureCategoryId"},
            listFormName:"",
            addFormName:"",
            listForm: new OfbizList({
                listFormName:"ChildProductFeatureCategories",
                listFormLocation:"component://kwikstore/widget/FeatureForms.xml",
                target:getTarget("ChildProductFeatureCategories",FEAT_FORMS),
                columnFields:getFields("ChildProductFeatureCategories",FEAT_FORMS),
                fieldFormFields:getFields("ChildProductFeatureCategories",FEAT_FORMS),
                columnFieldTitles:getColumnFieldTitles("ChildProductFeatureCategories",FEAT_FORMS),
                appContext:getAppContext("ChildProductFeatureCategories",FEAT_FORMS),
                emptyListMessage:"No content found for this category. Please add existing content or create new content to add.",
                remoteFormData: {
                    formData: {
                        formName: "ChildProductFeatureCategories",
                        formLocation: "component://kwikstore/widget/FeatureForms.xml",
                        listType: "grid"
                    },
                    parameters: {"productFeatureCategoryId": ""}
                }
            }),
            addForm: new OfbizForm({
                formName:"AddChildProductFeatureCategory",
                local:true,
                appContext:getAppContext("AddChildProductFeatureCategory",FEAT_FORMS),
                targets:getTargets("AddChildProductFeatureCategory",FEAT_FORMS),
                formLocation:"component://kwikstore/widget/FeatureForms.xml",
                fields:getFields("AddChildProductFeatureCategory",FEAT_FORMS)        
            })
        },
        /* {
          title:"Feature Prices",
          addContainerTitle:"Create Feature Price",
          listContainerTitle:"Feature Prices",
          entityName:"ProductFeaturePrice",
          keyMap:{fieldName:"productFeatureId"},
          addFormName:"CreateFeaturePrice",
          listFormName:"ListFeaturePrice",
          addForm: new OfbizForm({
            local:true,
            formName:"CreateFeaturePrice",
            formLocation:"component://kwikstore/widget/FeatureForms.xml",
            fields:getFields("CreateFeaturePrice",FEAT_FORMS),
            idFieldName:"productFeatureId",
            target:getTarget("CreateFeaturePrice",FEAT_FORMS),
            titleDescriptionField:getTitleDescriptionField("CreateFeaturePrice",FEAT_FORMS),
            appContext:"catalog"
          }),
          listForm:new OfbizList({
            listType:"grid",
            listFormName:"ListFeaturePrice",
            listFormLocation:"component://kwikstore/widget/FeatureForms.xml",
            columnFields:getFields("ListFeaturePrice",FEAT_FORMS),
            columnFieldTitles:getColumnFieldTitles("ListFeaturePrice",FEAT_FORMS),
            appContext:"catalog",
            emptyListMessage:"No Prices For This Product Feature.  Use add form to add prices."
          }),
          appContext:"catalog"
        },
        {
          title:"Feature Suppliers",
          addContainerTitle:"Create Feature Supplier",
          listContainerTitle:"Feature Suppliers",
          entityName:"ProductFeaturePrice",
          keyMap:{fieldName:"productFeatureId"},
          addFormName:"CreateSupplierProductFeature",
          listFormName:"EditSupplierProductFeatures",
          addForm: new OfbizForm({
            local:true,
            formName:"CreateSupplierProductFeature",
            formLocation:"component://kwikstore/widget/FeatureForms.xml",
            fields:getFields("CreateSupplierProductFeature",FEAT_FORMS),
            idFieldName:"productFeatureId",
            target:getTarget("CreateSupplierProductFeature",FEAT_FORMS),
            titleDescriptionField:getTitleDescriptionField("CreateSupplierProductFeature",FEAT_FORMS),
            appContext:"catalog"
          }),
          listForm:new OfbizList({
            listType:"grid",
            listFormName:"EditSupplierProductFeatures",
            listFormLocation:"component://kwikstore/widget/FeatureForms.xml",
            columnFields:getFields("EditSupplierProductFeatures",FEAT_FORMS),
            columnFieldTitles:getColumnFieldTitles("EditSupplierProductFeatures",FEAT_FORMS),
            appContext:"catalog",
            emptyListMessage:"No Prices For This Product Feature.  Use add form to add prices."
          }),
          appContext:"catalog"
        } */
      ],
   /*  childComponent:new ComponentConfig({
      title:"Features",
      listForm:new OfbizList({
        listType:"form",
        listFormName:"EditFeatureCategoryFeatures",
        listFormLocation:"component://kwikstore/widget/FeatureForms.xml",
        columnFields:getFields("EditFeatureCategoryFeatures",FEAT_FORMS),
        columnFieldTitles:getColumnFieldTitles("EditFeatureCategoryFeatures",FEAT_FORMS),
        idFieldName:getIdFieldName("EditFeatureCategoryFeatures",FEAT_FORMS),
        target:getTarget("EditFeatureCategoryFeatures",FEAT_FORMS),
        appContext:"catalog",
        remoteFormData:{
          formData:{
            formName:"EditFeatureCategoryFeatures",
            formLocation:"component://kwikstore/widget/FeatureForms.xml",
            listType:"form",

          },
          parameters:{"productFeatureCategoryId":""}
        },
        emptyListMessage:"No Features found"
      }),
      addForm:new OfbizForm({
        local:true,
        formName:"EditProductFeature",
        formLocation:"component://kwikstore/widget/FeatureForms.xml",
        fields:getFields("EditProductFeature",FEAT_FORMS),
        appContext:"catalog",
        idFieldName:"productFeatureId",
        targets:getTargets("EditProductFeature",FEAT_FORMS),
        titleDescriptionField:"description"
      }),
      findForm:new OfbizForm({}),
      breadCrumbData:{
        displayPrefix:"Features for ",
        label:"",
        level:2,
        selectedValue:{
          "event":"list",
          "type":"",
          "data":{
            formData:{
              formName:"",
              formLocation:"component://kwikstore/widget/FeatureForms.xml"
            }
          }
        },
        addFormText:"Create Product Feature",
        editFormText:"Update Product Feature"
      },
      relations:[
        {
          title:"Feature Prices",
          addContainerTitle:"Create Feature Price",
          listContainerTitle:"Feature Prices",
          entityName:"ProductFeaturePrice",
          keyMap:{fieldName:"productFeatureId"},
          addFormName:"CreateFeaturePrice",
          listFormName:"ListFeaturePrice",
          addForm: new OfbizForm({
            local:true,
            formName:"CreateFeaturePrice",
            formLocation:"component://kwikstore/widget/FeatureForms.xml",
            fields:getFields("CreateFeaturePrice",FEAT_FORMS),
            idFieldName:"productFeatureId",
            target:getTarget("CreateFeaturePrice",FEAT_FORMS),
            titleDescriptionField:getTitleDescriptionField("CreateFeaturePrice",FEAT_FORMS),
            appContext:"catalog"
          }),
          listForm:new OfbizList({
            listType:"grid",
            listFormName:"ListFeaturePrice",
            listFormLocation:"component://kwikstore/widget/FeatureForms.xml",
            columnFields:getFields("ListFeaturePrice",FEAT_FORMS),
            columnFieldTitles:getColumnFieldTitles("ListFeaturePrice",FEAT_FORMS),
            appContext:"catalog",
            emptyListMessage:"No Prices For This Product Feature.  Use add form to add prices."
          }),
          appContext:"catalog"
        },
        {
          title:"Feature Suppliers",
          addContainerTitle:"Create Feature Supplier",
          listContainerTitle:"Feature Suppliers",
          entityName:"ProductFeaturePrice",
          keyMap:{fieldName:"productFeatureId"},
          addFormName:"CreateSupplierProductFeature",
          listFormName:"EditSupplierProductFeatures",
          addForm: new OfbizForm({
            local:true,
            formName:"CreateSupplierProductFeature",
            formLocation:"component://kwikstore/widget/FeatureForms.xml",
            fields:getFields("CreateSupplierProductFeature",FEAT_FORMS),
            idFieldName:"productFeatureId",
            target:getTarget("CreateSupplierProductFeature",FEAT_FORMS),
            titleDescriptionField:getTitleDescriptionField("CreateSupplierProductFeature",FEAT_FORMS),
            appContext:"catalog"
          }),
          listForm:new OfbizList({
            listType:"grid",
            listFormName:"EditSupplierProductFeatures",
            listFormLocation:"component://kwikstore/widget/FeatureForms.xml",
            columnFields:getFields("EditSupplierProductFeatures",FEAT_FORMS),
            columnFieldTitles:getColumnFieldTitles("EditSupplierProductFeatures",FEAT_FORMS),
            appContext:"catalog",
            emptyListMessage:"No Prices For This Product Feature.  Use add form to add prices."
          }),
          appContext:"catalog"
        }
      ]
    }) */
    
  }

export const baseMenuItems:NbMenuItem[] = [
    {title:"Feature Categories",group:true},
    {title:"List Product Feature Categories",icon:"list-outline",link:"/admin/features"},
    {title:"New Product Feature Category",icon:"plus-outline"},
]

export const featureMenuItems:NbMenuItem[] = [
  {title:"Features",group:true},
  {
    title:"List Product Features",
    icon:"list-outline",
    link:"/admin/features/feature",
    data:{
      event:"list",
      type:"ListProductFeature",
      data:{
        formData:{
          formName:"ListProductFeature",
          formLocation:"component://kwikstore/widget/FeatureForms.xml"
        },
        appContext:"catalog",
      }
    }
  },
  {
    title:"New Product Feature",
    icon:"plus-outline",
    link:"/admin/features/feature/new",
    data:{
      event:"add"
    }
  },
]
export const featureTypeMenuItems:NbMenuItem[] = [
  {title:"Feature Types",group:true},
  {
    title:"List Product Feature Types",
    icon:"list-outline",
    link:"/admin/features/feature-types",
    data:{
      event:"list",
      type:"ListFeatureTypes",
      data:{
        formData:{
          formName:"ListFeatureTypes",
          formLocation : "component://kwikstore/widget/FeatureForms.xml",
        }
      }
    }
  },
  {
    title:"New Product Feature Type",
    icon:"plus-outline",
    link:"/admin/features/feature-types/new",
    data:{
      event:"add",
      type:"EditFeatureType",
      data:{
        formData:{
          formName:"EditFeatureType",
          formLocation:"component://kwikstore/widget/FeatureForms.xml"
        }
      }
    }
  },
]
export const featureGroupsMenuItems:NbMenuItem[] = [
  {title:"Feature Groups",group:true},
  {
    title:"List Product Feature Groups",
    icon:"list-outline",
    link:"/admin/features/feature-groups",
    data:{
      event:"list",
      type:"EditProductFeatureGroups",
      data:{
        formData:{
          formName:"EditProductFeatureGroups",
          formLocation:"component://kwikstore/widget/FeatureForms.xml"
        }
      }
    }
  },
  {
    title:"New Product Feature Group",
    icon:"plus-outline",
    link:"/admin/features/feature-groups/new",
    data:{
      event:"add",
      type:"EditProductFeatureGroup",
      data:{
        formData:{
          formName:"EditProductFeatureGroup",
          formLocation:"component://kwikstore/widget/FeatureForms.xml"
        },
        appContext:"catalog"
      }
    }
  },
]

